import { STAFF_LIST } from "@/actions/actionType";

const staffListReducer = (state = {}, action) => {
  let newState = {};
  switch (action.type) {
    case STAFF_LIST:
      newState = {...state, staffList: action.list} 
      return newState;
    default:
      return state;
  }
}

export default staffListReducer;